import { IFile } from "../domain/models/File";
import { IManagementFlat } from "../domain/models/Management";
import { BaseModelImpl } from "./BaseModelImpl";

export class ManagementFlatModel
    extends BaseModelImpl<IManagementFlat>
    implements IManagementFlat
{
    id: string;
    files?: IFile[];

    isActive: boolean;
    languageCode: string;

    fullName: string;
    position: string;

    updatorId?: string;
    creatorId?: string;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: IManagementFlat) {
        super();
        this.assignData(data);
    }
}
